var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['toast-container', _vm.showToast? 'show': '', _vm.toastActive? 'active': '']},[_c('div',{class:['toast-main', _vm.theme ? _vm.theme : '']},_vm._l((_vm.msg.split('\n')),function(m){return _c('p',[_vm._v(_vm._s(m))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }